module.exports = __webpack_public_path__ + "static/media/ally_pro_1.15341d7b.jpg";